module.exports = __webpack_public_path__ + "static/media/discharge.d572f7e8.svg";